
<template>
<!-- 谷歌地图组件 -->

<!-- main.js中配置Vue.prototype.Map = 'zh-CN'使用高德地图 'en-US'使用谷歌地图 -->
<!-- 国内加载谷歌地图sdk速度缓慢,需要使用谷歌地图时再将index.html解除注释 -->
    <div id="map"></div>
</template>
<script>
      let map=null
      let markers=[]
      let marker=null
      let labels='ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let markerCluster=null
      let contentString=''
      let infowindow=null
import { getDeviceAddressList } from '@/api/login'
export default {
  data(){
    return{
      offset:1,
      //默认加载10W台设备，如果超过这个数量页面会造成卡顿
      limit:100000
    }
  },
  mounted(){
    //创建地图
    this.initMap()
  },
  methods:{
    initMap() {
      //清空所有数据
      map=null
      markers=[]
      marker=null
      labels='ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      markerCluster=null
      contentString=''
      infowindow=null
      //创建地图
      var uluru = {lat: 1.3238320056192325, lng: 103.84289822703454};
      var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 12,
      center: uluru,
      scaleControl: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP
      })
      //信息窗体
      infowindow = new google.maps.InfoWindow({
      content: ''
      })
      //获取后端设备经纬度等信息
      getDeviceAddressList(this.offset,this.limit)
      .then((res)=>{
      res.data.data.list.forEach((element,index)=>{
        //创建点
          marker = new google.maps.Marker({
          position: {lat: Number(element.deviceLatitude) , lng: Number(element.deviceLongitude)},
          map: map,
          //添加点的信息
          con:`<p style="margin: 10px 0px 0px 0px;">${this.$t('lang.dashboard.Serials')}：${element.deviceSn}</p>
          <p>${this.$t('lang.dashboard.name')}：${element.deviceName}</p>
        <p>${this.$t('lang.dashboard.ADDRESS')}：${element.deviceAddress}</p>`
      })
      //鼠标移入事件
      marker.addListener('mouseover', ()=> {
      //如果语言被切换，重新给点的内容赋值
      markers[index].con=`<p style="margin: 10px 0px 0px 0px;">${this.$t('lang.dashboard.Serials')}：${element.deviceSn}</p>
          <p>${this.$t('lang.dashboard.name')}：${element.deviceName}</p>
        <p>${this.$t('lang.dashboard.ADDRESS')}：${element.deviceAddress}</p>`
      // 将点的信息添加至信息窗体
      infowindow.setContent(markers[index].con)
      //打开点
      infowindow.open(map,markers[index])
      })
      //鼠标移出事件
      marker.addListener('mouseout', ()=> {
        //关闭信息窗体
      infowindow.close()
      })
      //点击事件，点击跳转设备详细信息页面
      marker.addListener('click',()=>{
        this.$router.push({
        name: 'Particulars',
        params: {id: element.deviceId}
        })
      })
      //将点push到聚合数组
      markers.push(marker)
      })
      //创建点聚合
      markerCluster = new MarkerClusterer(map, markers,
             {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'}
       )
      })
      }
}
}
</script>
<style scoped>
#map{
  width: 100%;
  margin: 0.2rem auto 0 auto;
  display: inline-block;
  height: 88vh;
}
</style>
